import { forwardRef, useImperativeHandle } from 'react';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import { ZINDEX_OVER_MENU } from '@sdk/components/ui/ui.consts';
import type { DocumentData } from '@sdk/users/types/DocumentData';

import { useDocumentPreview } from '@web/users/documents/DocumentPreview/documentPreview.hooks';

type Props = {
  document: DocumentData;
};

type ForwardedAttrs = {
  open: () => void;
};

const modalStyles = {
  overlay: { zIndex: ZINDEX_OVER_MENU },
  content: { zIndex: ZINDEX_OVER_MENU },
};

const DocumentPreview = ({ document }: Props, ref) => {
  const { isOpen, setIsOpen, preparePreview, previewUrl } = useDocumentPreview(document);

  useImperativeHandle(ref, () => ({
    open() {
      setIsOpen(true);
      preparePreview();
    },
  }));

  return (
    isOpen && (
      <Lightbox
        mainSrc={previewUrl}
        onCloseRequest={() => {
          setIsOpen(false);
        }}
        reactModalStyle={modalStyles}
      />
    )
  );
};

export default forwardRef<ForwardedAttrs, Props>(DocumentPreview);
